module.exports = __webpack_public_path__ + "static/media/wt2.7de89030.png";